import React from "react";

const CreditUdharani = () => {
  return (
    <div className="page-content">
      <div className="container-fluid">
        <h2>CreditUdharani</h2>
        <p>Content for CreditUdharani page will go here.</p>
      </div>
    </div>
  );
};

export default CreditUdharani;
